import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, advanceParamCheck, authScopesCheck } from '../../utils';

export interface AuthorizeOption extends Partial<GeneralInvokeOption> {
    scopes: Array<string>;
    invalidParamObj?: '';
}

export function deauthorize(option: GeneralInvokeOption) {
    return MacleJSBridge.beforeInvoke(APINames.Native.DEAUTHORIZE_PERMISSION, option);
}

export function cancelAuthorize(option: AuthorizeOption) {
    if (!option.scopes) {
        return logErrorAndRunFail(
          APINames.Native.CANCLE_AUTHORIZE_PERMISSION,
          option,
          'parameter error:parameter.scopes should be Array<string> instead of Undefined.'
        );
      }
      if (advanceParamCheck(APINames.Native.CANCLE_AUTHORIZE_PERMISSION, option, { scopes: [''] })) {
        const invalidScopes = authScopesCheck(option.scopes);
        if (invalidScopes.length > 0) {
          return logErrorAndRunFail(
            APINames.Native.CANCLE_AUTHORIZE_PERMISSION,
            option,
            `parameter error: invalid scopes ${invalidScopes}`
          );
        }
        return MacleJSBridge.beforeInvoke(APINames.Native.CANCLE_AUTHORIZE_PERMISSION, option);
      }
      return option.invalidParamObj;    
}